import React from "react";
import { rowColumn, tableOptions } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";

const secondaryOptions = structuredClone(assignStatusSecondaryOptions);
secondaryOptions["Finalised"] = assignStatusSecondaryOptions["Finalised"];

export const finalisedListTable = (currPath: string, assessors: any): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
    isFilter: true,
    filterElements: [{ label: "Finalised", value: "Finalised" }],
    filterType: "search",
    filterKeyColumns: ["applicationBase.kindergarten.fundedKinderName", "applicationBase.kindergarten.kindergartenNameOther"],
  },
  {
    label: "Assigned Assessor",
    column: "applicationBase.assignAssessor.assignedAssessorName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignAssessor.AssignedAssessorName",
    isFilter: true,
    filterType: "multiselect",
    filterElements: assessors,
  },
  {
    label: "Status",
    column: "applicationBase.assignStatus.statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignStatus.StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions([assignStatusPrimaryOptions.find((x) => x.value === "Finalised")], secondaryOptions),
  },
  {
    label: "Date Submitted",
    column: "applicationBase.dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "ApplicationBase.DateSubmitted",
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.applicationBase.discriminator}/${rowData.id}`}>View Details</a>,
  },
];

export const finalisedTableOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  filters: {
    "applicationBase.assignStatus.statusComputed": {
      searchFilter: [
        "Finalised - Outcome sent",
        "Finalised - KIMS entry complete",
        "Finalised - Application finalised",
        "Finalised - Appeal Received",
        "Finalised - Transfer Received",
        "Finalised - Withdrawn",
        "Finalised - Unable to process",
        "Finalised - Add Info not received",
      ],
    },
  },
};
